module.exports = __webpack_public_path__ + "img/head.825ac7ab.png";